
// EXPORTED/GLOBALS NOTES:
// YT is from https://www.youtube.com/iframe_api
// onYouTubeIframeAPIReady is called from the iframe_api
// stopVideo may also be called from the iframe_api

/* globals YT */

export {stopVideo, load_ytplayer};

import {state} from './index.js';

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;


// ---------------------------
// Global Variables
// ---------------------------

export const ytplayerState = {
	yt_clip_id: null,
	yt_clip_playing: false,
	yt_clip_start: 0,
	yt_clip_end: 0,
	yt_clip_monitor: null,
	yt_player: null,
};


// ---------------------------
// New iFrame Player
// ---------------------------

function load_ytplayer() {
	if (state.owner) {
		ytplayerState.yt_clip_id = "YUGRnXhc2yM";
	} else {
		ytplayerState.yt_clip_id = "mxeyeQqsAYs";
	}
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function onYouTubeIframeAPIReady() {
	ytplayerState.yt_player = new YT.Player('player_content', {
		videoId: ytplayerState.yt_clip_id,
		events: {
			'onReady': onPlayerReady
		},
		playerVars: {
			rel: 0,
			showinfo: 0,
			iv_load_policy: 3,
			playsinline: 1,
		}
	});
}

function onPlayerReady(event) {
	event.target.playVideo();
}

function stopVideo() {
	ytplayerState.yt_player.stopVideo();
}

